export default __webpack_public_path__ + "static/media/gs8-screens.585779fc.jpg";